module.exports = __webpack_public_path__ + "static/media/defaultpic.6798943f.jpg";